import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';

// Sentry browser SDK — only initialise when DSN is configured (so dev
// builds don't ship spurious local errors). Reads from CRA's process.env
// today; the Vite migration will switch to import.meta.env without
// touching this code.
const sentryDsn = process.env.REACT_APP_SENTRY_DSN || '';

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: true,
      }),
    ],
    // Capture 10% of transactions for performance monitoring
    tracesSampleRate: 0.1,
    // No session replay on the happy path; capture 100% of sessions
    // that produce an error so we can replay the failure
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    environment: process.env.NODE_ENV || 'production',
    release: process.env.REACT_APP_RELEASE || 'unknown',
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
